<template>
    <div class="free-addon">
        <div class="free-addon__header">
            <div>
                <text-decorator
                    :size="FontSize.xl"
                    weight="bold"
                >
                    Gratis
                </text-decorator>
            </div>
            <div>
                <text-decorator :size="FontSize.xl">
                    Onbeperkt
                </text-decorator>
            </div>
            <div>
                <text-decorator :size="FontSize.lg">
                    {{ props.name }}
                </text-decorator>
            </div>
        </div>
        <div class="free-addon__input">
            <input-group :model-value="0">
                <template #input>
                    <number-input disabled hide-value />
                </template>
            </input-group>
        </div>
        <button
            v-tooltip.info="props.tooltip"
            class="free-addon__tooltip"
            type="button"
        >
            <svg-icon
                :icon="CircleInfoIcon"
                :size="IconSize.xs"
                :color="'primary'"
                is-custom-icon
            />
        </button>
    </div>
</template>

<script setup lang="ts">
    import { FontSize, IconSize, NumberInput } from '@keyvue/one-ui';
    import CircleInfoIcon from '@keyvue/one-awesome-icons/icons/regular/circle-info.svg?component';

    interface Props {
        name: string
        tooltip: string
    }

    const props = defineProps<Props>();
</script>

<style scoped lang="scss">
    .free-addon {
        position: relative;
        border-radius: size(sm);
        border: 1px solid color(gray-300);

        &__header {
            display: flex;
            flex-direction: column;
            padding: size(md) size(md) size(sm);
            gap: size(xs);
        }

        &__input {
            display: flex;
            padding: 0 0 size(md) size(md);
        }

        &__tooltip {
            position: absolute;
            right: size(sm);
            top: size(sm);
            padding: 0;
            border: 0;
            background: none;
            outline: 0;
            cursor: pointer;
        }
    }
</style>
